export default {
  title: "{{packageTypeName}} - Set Anchor Date",
  startPackage: "Start {{packageTypeName}}",
  selectedCount: "{{count}} selected",
  missingInfo: "Information is missing",
  missingInfoDescription: "Please select targets before accessing this page.",
  success: "Procedure started successfully",
  error: "Failed to start procedure",
};
